<footer *ngIf="internalPortal === false">
  <div class="grid-container partner-footer" *ngIf="footerHtml" [innerHTML]="footerHtml"></div>
  <div class="grid-container text-center" [class.partner-footer]="!footerHtml" [innerHTML]="'footer.partner' | translate: {'logo': '<img src=\'gfx/co2online_fuss_01.png\' alt=\'www.co2online.de\'>'}"></div>
</footer>
